var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVyooLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vyoo-logo_svg__a",
    d: "M7.26.09C3.26.09.018 3.332.018 7.332v17.382c0 4 3.243 7.243 7.242 7.243h17.383c4 0 7.242-3.243 7.242-7.243V7.332c0-4-3.242-7.242-7.242-7.242H7.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vyoo-logo_svg__c",
    d: "M.106 2.075c1.077.082 1.696.634 1.966 2.732l1.077 7.672c.135 1.077 1.104 1.436 2.1 1.436.728 0 1.65-.192 2.37-1.132l5.548-8.776c.593-.911.809-1.38.809-1.987 0-1.822-2.586-1.96-2.613-1.905l-5.332 9.55-.485-5.023C5.41 2.792 5.088 1.578 4.36.832 3.85.309 3.257.089 2.476.089.294.087.052 2.075.106 2.075z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3742",
    fillRule: "nonzero",
    d: "M59.122 12.753c.482 0 .824.389.824.777 0 .105-.016.21-.063.3l-3.203 7.524C56.183 22.536 55.297 23 54.24 23c-.576 0-1.105-.21-1.105-.718 0-.389.327-.718.778-.718.109 0 .202.015.31 0 .374-.03.685-.195.871-.599l.374-.807-2.69-6.343a.825.825 0 01-.047-.27c0-.388.327-.792.84-.792.326 0 .637.194.777.523l1.99 4.937 1.99-4.937c.11-.314.436-.523.794-.523zm5.597-.09c2.41 0 3.872 1.72 3.872 3.785 0 2.079-1.462 3.8-3.872 3.8s-3.872-1.721-3.872-3.8c0-2.065 1.462-3.785 3.872-3.785zm8.91 0c2.41 0 3.871 1.72 3.871 3.785 0 2.079-1.462 3.8-3.872 3.8s-3.871-1.721-3.871-3.8c0-2.065 1.461-3.785 3.871-3.785zM51.144 10c.575 0 .995.449.995.928 0 .12-.03.239-.078.344l-3.234 7.943c-.233.569-.824.943-1.43.943h-.156c-.622 0-1.212-.374-1.446-.943l-3.234-7.943a.862.862 0 01-.062-.344c0-.434.389-.928.98-.928.404 0 .777.24.917.613l2.923 7.51 2.908-7.51a.994.994 0 01.917-.613zm13.574 4.084c-1.384 0-2.146 1.107-2.146 2.364 0 1.271.762 2.378 2.146 2.378 1.368 0 2.13-1.107 2.13-2.378 0-1.257-.762-2.364-2.13-2.364zm8.91 0c-1.384 0-2.146 1.107-2.146 2.364 0 1.271.762 2.378 2.145 2.378 1.369 0 2.13-1.107 2.13-2.378 0-1.257-.761-2.364-2.13-2.364z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vyoo-logo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vyoo-logo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M-3.301 35.276h38.506V-3.23H-3.301z",
    mask: "url(#vyoo-logo_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vyoo-logo_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vyoo-logo_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M-2.998 17.155h20.071V-3.153H-2.998z",
    mask: "url(#vyoo-logo_svg__d)"
  })))));
}

export default SvgVyooLogo;